<template>
  <div class="animated fadeIn">
    
    <h4 class="mb-3">Onedio.* Overviews</h4>
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="mt-pb-0">
            <h4 id="traffic" class="card-title mb-0 text-center">Total Pageviews</h4>
          </b-card-body>
          <div v-if="loaderOverviews">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="pieChartStatus">
            <pie-chart-pageview v-if="request" :renderData=renderCommand>
            </pie-chart-pageview>
          
          <b-card-body class="pb-0">
              <p class="h6 half-left"> onedio.com</p> <p class="h6 half-right">:  {{comPageView}} </p>
            <p class="h6 half-left"> onedio.co</p> <p class="h6 half-right"> : {{coPageView}} </p>
            <p class="h6 half-left"> onedio.ru</p> <p class="h6 half-right"> : {{ruPageView}} </p>
            <div class="text-right">Last {{filterDates.length}} Days</div>
          </b-card-body>
          </div>
          <b-card-body class="pb-0">
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="mt-pb-0">
            <h4 id="traffic" class="card-title mb-0 text-center">Total Session</h4>
          </b-card-body>
          <div v-if="loaderOverviews">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="pieChartStatus">
          <pie-chart-session v-if="request" :renderData=renderCommand >
            </pie-chart-session>
          
          <b-card-body class="pb-0">
           <p class="h6  half-left"> onedio.com</p> <p class="h6 half-right">: {{comSession}} </p>
            <p class="h6 half-left"> onedio.co</p> <p class="h6 half-right"> : {{coSession}} </p>
            <p class="h6 half-left"> onedio.ru</p> <p class="h6 half-right"> : {{ruSession}} </p>
            <div class="text-right">Last {{filterDates.length}} Days</div>
          </b-card-body>
          </div>
          <b-card-body class="pb-0">
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="mt-pb-0">
            <h4 id="traffic" class="card-title mb-0 text-center">Total Users</h4>
          </b-card-body>
          <div v-if="loaderOverviews">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="pieChartStatus">
          <pie-chart-user v-if="request" :renderData=renderCommand >
            </pie-chart-user>
          
          <b-card-body class="pb-0">
            <p class="h6 half-left"> onedio.com </p> <p class="h6 half-right">: {{comUsers}} </p>
            <p class="h6 half-left"> onedio.co </p> <p class="h6 half-right"> : {{coUsers}} </p>
            <p class="h6 half-left"> onedio.ru </p> <p class="h6 half-right"> : {{ruUsers}} </p>
            <div class="text-right">Last {{filterDates.length}} Days</div>
          </b-card-body>
          </div>
          <b-card-body class="pb-0">
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="mt-pb-0">
            <h4 id="traffic" class="card-title mb-0 text-center">Avg. Bounce Rate</h4>
            </b-card-body>
          <div v-if="loaderOverviews">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="pieChartStatus">
          <pie-chart-rate v-if="request" :renderData=renderCommand >
            </pie-chart-rate>
          
          <b-card-body class="pb-0">
            <p class="h6 half-left"> onedio.com</p> <p class="h6 half-right">: {{comRates}} </p>
            <p class="h6 half-left"> onedio.co </p> <p class="h6 half-right"> : {{coRates}} </p>
            <p class="h6 half-left"> onedio.ru </p> <p class="h6 half-right"> : {{ruRates}} </p>
            <div class="text-right">Last {{filterDates.length}} Days</div>
          </b-card-body>
          </div>
          <b-card-body class="pb-0">
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div>
      
      <b-card>
        <div>
          <b-row>
            <b-col sm="6">
              <h4 id="traffic" class="card-title mb-0">Total Datas</h4>
            </b-col>
            <b-col sm="6">
              <h4 id="traffic" class="card-title mb-0" v-if="selectedDatas === 'revenues' && selectedCurrency==='TRY'">  Total Revenues: {{generalTotal}} ₺ ({{filterDates.length}} days)</h4>
              <h4 id="traffic" class="card-title mb-0" v-if="selectedDatas === 'revenues' && selectedCurrency==='USD'">  Total Revenues: $ {{generalTotal}} ({{filterDates.length}} days)</h4>
              <h4 id="traffic" class="card-title mb-0" v-if="selectedDatas === 'revenues' && selectedCurrency==='RUB'">  Total Revenues: {{generalTotal}} ₽ ({{filterDates.length}} days)</h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedDatas === 'impressions'">  Avg. {{selectedDatas[0].toUpperCase()}}{{selectedDatas.substring(1)}}: {{generalTotal}}% ({{filterDates.length}} days)  </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedDatas === 'ecpms'">  Avg. {{selectedDatas[0].toUpperCase()}}{{selectedDatas.substring(1)}}: {{generalTotal}}% ({{filterDates.length}} days)  </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedDatas === 'ad_requests'">  Total Ad Requests: {{generalTotal}}K ({{filterDates.length}} days) </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedDatas === 'ctrs'">  Avg. {{selectedDatas[0].toUpperCase()}}{{selectedDatas.substring(1)}}: {{generalTotal}}% ({{filterDates.length}} days) </h4>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="3">
              <label for="month1">Datas</label>
             <b-form-select id="month1"  v-model="selectedDatas" :plain="true" :options="dataOptions">
              </b-form-select> 
              <b-form-select id="traffic" class="card-title mb-0" v-if="selectedDatas === 'revenues'" v-model="selectedCurrency" :plain="true" :options="currencyOptions">
              </b-form-select>
            </b-col>
            <b-col sm="3">
              <label for="month1">Services</label>
              <v-select :on-change="change" v-model="optionSelected" :multiple=true :options="vSelectText"></v-select>
            </b-col>
            <b-col sm="3">
              <label for="month1">Sites</label>
              <v-select :on-change="change" v-model="siteSelected" :multiple=true :options="sitesSelected"></v-select>
            </b-col>
          </b-row>
          <div v-if="loaderStatus">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="chartStatus">
            <all-component chartId="main-chart-01" class="chart-wrapper"
              style="height:300px;margin-top:40px;" :renderData=renderCommand height="300" ></all-component>
          </div>
        </div>
      </b-card>
    </div>
    <b-card>
      <data-table :renderData=renderCommand :selectedSites=siteSelected :selectedServices=optionSelected />
    </b-card>
  </div>
</template>

<script>
  import CardBarChartExample from './dashboard/CardBarChartExample'
  import BarBouncerate from './dashboard/BarBouncerate'
  import JWT from 'jsonwebtoken'
  import loader from 'vue-spinner/src/PulseLoader'
  import VueHotelDatepicker from '@northwalker/vue-hotel-datepicker'
  import Dateformatter from '../plugins/dateFormatter'
  import AllComponent from './dashboard/MainChartAllSites'
  import {
    parse
  } from 'path'
  import numeral from 'numeral'
  import DataTable from './base/Tables'
  import PieChartUser from '../views/charts/PieChartUser'
  import PieChartPageview from '../views/charts/PieChartPageview'
  import PieChartSession from '../views/charts/PieChartSession'
  import dateFormatter from '../plugins/dateFormatter'
  import PieChartRate from '../views/charts/PieChartRate';
  import format from 'date-fns/format'
  export default {
    name: 'dashboard',
    props:['setData'],
    components: {
      CardBarChartExample,
      DataTable,
      loader,
      VueHotelDatepicker,
      PieChartUser,
      PieChartPageview,
      PieChartSession,
      PieChartRate,
      AllComponent
    },
    data: function () {
      return {
        /* threeObject: {
          active: false,
          'btn btn-light': true
        },
        sevenObject: {
          active: true,
          'btn btn-light': true
        },
        fourTeenObject: {
          active: false,
          'btn btn-light': true
        },
        thirtyObject: {
          active: false,
          'btn btn-light': true
        },
        oneEightyObject: {
          active: false,
          'btn btn-light': true
        }, */
        isloading: false,
        vSelectText: ['yandex_ads', 'facebook', 'adx', 'relap', 'adform'],
        dataDate: '',
        pageView: 0,
        session: 0,
        users: 0,
        rates:0,
        comUsers:0,
        comPageView:0,
        comSession:0,
        comRates:0,
        coUsers:0,
        coPageView:0,
        coSession:0,
        coRates:0,
        ruUsers:0,
        ruPageView:0,
        ruSession:0,
        ruRates:0,
        renderCommand: 0,
        selectedCurrency: 'TRY',
        optionSelected: ['adx'],
        loading: true,
        chartStatus: false,
        loaderStatus: true,
        loaderOverviews:true,
        pieChartStatus:false,
        minDate: '2018/8/7',
        startDate: '2018/8/7',
        endDate: '',
        selectedDatas: 'revenues',
        totalRevenue: 0,
        sitesSelected: ['onediocom', 'onedioru', 'onedioco'],
        siteSelected: ['onediocom'],
        request: false,
        generalTotal: 0,
        dataOptions:[{text:'Revenue', value:'revenues'},
                {text:'Impression', value:'impressions'},
                {text:'Ecpm',value:'ecpms'},
                {text:'Ad Request',value:'ad_requests'},
                {text:'Ctr',value:'ctrs'}],
        currencyOptions:[{text:'₺ (TL)',value:'TRY'},
                {text:'$ (USD)',value:'USD'},
                {text:'₽ (RUB)',value:'RUB'}],
        filterDates:[],
        dateFormat: 'D MMM',
        newdateFormat:'YYYY-MM-DD',
        dateOne: '',
        dateTwo: '',
        isRevenue:false,
        isImpression:false,
        isEcpm:false,
        isAdRequest:false,
        isCtr:false,
      }
    },
    
    methods: {
      /*  async changeDateVisible(visible){
         this.dateOne=''
         this.dateTwo=''
        if (visible === '3Visible') {
          this.$store.dispatch('SET_MAIN_ITEMS_3Day')
          this.$store.dispatch('MAIN_OVERVIEWS_3Day_DATA')
          await this.setChartData()
          this.threeObject.active = true;
          this.sevenObject.active = false;
          this.fourTeenObject.active = false;
          this.thirtyObject.active = false;
          this.oneEightyObject.active = false;
        } else if (visible === '7Visible') {
          this.$store.dispatch('SET_MAIN_ITEMS_WEEKLY')
          this.$store.dispatch('MAIN_OVERVIEWS_WEEKLY_DATA')
          await this.setChartData()
          this.threeObject.active = false;
          this.sevenObject.active = true;
          this.fourTeenObject.active = false;
          this.thirtyObject.active = false;
          this.oneEightyObject.active = false;
        } else if (visible === '14Visible') {
          this.$store.dispatch('SET_MAIN_ITEMS_14Day')
          this.$store.dispatch('MAIN_OVERVIEWS_14Day_DATA')
          await this.setChartData()
          this.threeObject.active = false;
          this.sevenObject.active = false;
          this.fourTeenObject.active = true;
          this.thirtyObject.active = false;
          this.oneEightyObject.active = false;

        } else if (visible === '30Visible') {
          this.$store.dispatch('SET_MAIN_ITEMS_MONTHLY')
          this.$store.dispatch('MAIN_OVERVIEWS_MONTHLY_DATA')
          await this.setChartData()
          this.threeObject.active = false;
          this.sevenObject.active = false;
          this.fourTeenObject.active = false;
          this.thirtyObject.active = true;
          this.oneEightyObject.active = false;

        } else if (visible === '180Visible') {
          this.$store.dispatch('SET_MAIN_ITEMS_180Day')
          this.$store.dispatch('MAIN_OVERVIEWS_180Day_DATA')
          await this.setChartData()
          this.threeObject.active = false;
          this.sevenObject.active = false;
          this.fourTeenObject.active = false;
          this.thirtyObject.active = false;
          this.oneEightyObject.active = true;
        }
         let label = this.selected
          let service = this.optionSelected
          let data = await this.selectedDatas
          let site = this.siteSelected
          let currency= this.selectedCurrency
          this.$store.dispatch('OPTIONS_CHART', {
            label,
            service,
            data,
            site,
            currency
          })
          await this.renderCommand++;
        setTimeout(async () => {
          this.loaderStatus = false
          this.chartStatus = true
          this.loaderOverviews=false,
          this.pieChartStatus=true,
          this.generalTotal = await this.$store.state.generalTotal.toFixed(2)
          this.filterDates=await this.$store.state.itemsData.filterDates
        }, 3000); 
      }, */
      async change(e) {
        let label = this.selected
        let service = this.optionSelected
        let data = await this.selectedDatas
        let site = this.siteSelected
        let currency= this.selectedCurrency
        await this.$store.dispatch('OPTIONS_CHART', {
          label,
          service,
          data,
          site,
          currency        })
        await this.renderCommand++;
        setTimeout(async () => {
          this.loaderStatus = false
          this.chartStatus = true
          this.generalTotal = await this.$store.state.generalTotal.toFixed(2)
          this.filterDates=await this.$store.state.itemsData.filterDates
        }, 1000);
        
        //this.setChartData()
      },
     /*  async change_sidebar(){
        let label = this.selected
        let service = this.optionSelected
        let data = await this.isSidebarData
        this.selectedDatas=this.isSidebarData
        let site = this.siteSelected
        let currency= await this.isSidebarCurrency
        this.selectedCurrency=this.isSidebarCurrency
        await this.$store.dispatch('OPTIONS_CHART', {
          label,
          service,
          data,
          site,
          currency        })
        await this.renderCommand++;
        setTimeout(async () => {
          this.loaderStatus = false
          this.chartStatus = true
          this.generalTotal = await this.$store.state.generalTotal.toFixed(2)
          this.filterDates=await this.$store.state.itemsData.filterDates
        }, 1000);
      },
      getEndDate() {
        let date = new Date();
        date.setDate(date.getDate() - 1)
        return this.endDate = date.toString();
      },
      update(date) {
        console.log(date)
      },
      async confirm(date) {
        let date1 = this.dateOne
        let date2 = this.dateTwo
        this.$store.dispatch('SET_MAIN_ITEMS_SEARCH', {
          date1,
          date2
        });
        this.$store.dispatch('MAIN_OVERVIEWS_SEARCH_DATA', {date1,date2})
        this.threeObject.active = false;
        this.sevenObject.active = false;
        this.fourTeenObject.active = false;
        this.thirtyObject.active = false;
        this.oneEightyObject.active = false;
        await this.setChartData()
        setTimeout(async () => {
        this.generalTotal = await this.$store.state.generalTotal.toFixed(2)
        this.filterDates=await this.$store.state.itemsData.filterDates
         }, 2000);
      }, */
      setChartData(){
      this.chartStatus = false,
      this.loaderStatus = true,
      this.pieChartStatus=false
      this.loaderOverviews=true
      setTimeout(async () => {
        await this.renderCommand++;
        let label = this.selected
        let service = this.optionSelected
        let data = this.selectedDatas
        let site = this.siteSelected
        let currency= this.selectedCurrency
        if(this.$store.state.mainOverviewsData){
          if(this.$store.state.mainOverviewsData.datas){
            if(this.$store.state.mainOverviewsData.datas[0]){
              this.chartData = await this.$store.state.mainOverviewsData.datas[0]
              await this.setOverview(this.chartData.onediocomDatas,"onedio.com")
              await this.setOverview(this.chartData.onediocoDatas,"onedio.co")
              await this.setOverview(this.chartData.onedioruDatas,"onedio.ru")
            }
          }
        }
        await this.$store.dispatch('OPTIONS_CHART', {
          label,
          service,
          data,
          site,
          currency
        })
         this.generalTotal = await this.$store.state.generalTotal.toFixed(2) 
         this.filterDates=await this.$store.state.itemsData.filterDates
      this.chartStatus = true
      this.loaderStatus = false
      this.pieChartStatus=true
      this.loaderOverviews=false

      }, 2000);
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.newdateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.newdateFormat)
      }
      return formattedDates
    },
    setOverview(overviewData, siteName){
      this.filterDates=this.$store.state.itemsData.filterDates
      this.pageView=0
      this.session=0
      this.users=0
      this.rates=0
      overviewData.forEach(element => {
          this.pageView += parseInt(element.pageviews);
          this.session += parseInt(element.session);
          this.users += parseInt(element.users);
          this.rates+= parseFloat(element.bounce_rate)
        });
      let viewCount = numeral(this.pageView)
      this.pageView = viewCount.format().replace(/,/g, '.')
      viewCount = numeral(this.session)
      this.session = viewCount.format().replace(/,/g, '.')
      viewCount = numeral(this.users)
      this.users = viewCount.format().replace(/,/g, '.')
      viewCount=numeral(this.rates)
      let user=this.users
      let session=this.session
      let pageview=this.pageView
      let rate=this.rates
      if(this.filterDates){
        rate=rate/(this.filterDates.length)
      }
      
      rate=rate.toFixed(2)

      if(siteName === "onedio.com"){
        this.comUsers=this.users
        this.comPageView=this.pageView
        this.comSession=this.session
        this.comRates=rate
        this.$store.dispatch('SET_ONEDIOCOM_OVERVIEWS', {
          user,
          pageview,
          session,
          rate
        })
      }
      else if(siteName==="onedio.co"){
        this.coUsers=this.users
        this.coPageView=this.pageView
        this.coSession=this.session
        this.coRates=rate
        this.$store.dispatch('SET_ONEDIOCO_OVERVIEWS', {
         user,
          pageview,
          session,
          rate
        })
      }
      else if(siteName==="onedio.ru"){
        this.ruUsers=this.users
        this.ruPageView=this.pageView
        this.ruSession=this.session
        this.ruRates=rate
        this.$store.dispatch('SET_ONEDIORU_OVERVIEWS', {
         user,
          pageview,
          session,
          rate
        })
      }
      this.request=this.$store.state.request
    }
    }
    ,
    beforeCreate() {
      const token = $cookies.get('user')
      if (token) {
        JWT.verify(token, this.$store.state.jwtToken, (err, decode) => {
          if (err) {
            this.$router.push('/pages/login')
          }else this.$store.dispatch('SET_REQUEST', true)
        })
      } else this.$router.push('/pages/login')
    },
    async created() {
      let data=this.selectedDatas
      let label = this.selected
      let service = this.optionSelected
      let site = this.siteSelected
      let currency= this.selectedCurrency
      await this.$store.dispatch('OPTIONS_CHART', {
        label,
        service,
        data,
        site,
        currency
      })
        if(this.$store.state.request){
          await this.$store.dispatch('MAIN_OVERVIEWS_WEEKLY_DATA')
          await this.$store.dispatch('SET_MAIN_ITEMS_WEEKLY')
          await this.$store.dispatch('CURRENCY')
          
        }
       //this.setChartData()
        this.generalTotal = await this.$store.state.generalTotal
        
    },
     async mounted() {
      numeral.defaultFormat('0,0');
      setTimeout(async () => {
        this.request=this.$store.state.request
       if(this.request){
          //get overviews data
        this.chartData = this.$store.state.mainOverviewsData.datas[0]
        /* await this.setOverview(this.chartData.onediocomDatas,"onedio.com")
        await this.setOverview(this.chartData.onediocoDatas,"onedio.co")
        await this.setOverview(this.chartData.onedioruDatas,"onedio.ru") */
        
        }
      }, 3000);
      setTimeout( async() => {
        await this.setChartData()
        }, 2000);
        setTimeout( async() => {
          this.generalTotal = await this.$store.state.generalTotal.toFixed(2)
          this.filterDates=await this.$store.state.itemsData.filterDates
        },2000);
    },  
    watch: {
      selectedDatas(nValue, oValue){
        this.change()
      },
      selectedCurrency(nValue,oValue){
        this.change()
      },
      async setData(nValue,oValue){
        this.setChartData()
       
      }
    },
  }
</script>

<style scoped>
  #datepicker-trigger{
    width: 250px;
  }
  .half-left{
    width: 50%;
    float: left;
    text-align:right;
  }
  .half-right{
    width: 50%;
    float: left;
    text-align:left;
  }
  .loader{
    color: '#000000'
    
  }

</style>